export default {
  archived: 'archived',
  scheduled: 'scheduled',
  active: 'active'
};